import { Injectable } from "@angular/core";
import { RegistryDozSpecificationDto } from "@app/ui_models/web-response";

@Injectable({ providedIn: "root" })
export class BasketDozService {
  public basketItems: Set<RegistryDozSpecificationDto> = new Set();
  public selectedBaseId = 0;
  public beneficiaryIds: Set<number> = new Set();

  public basketHasItems(): boolean {
    return this.basketItems.size > 0;
  }

  public allItems(): RegistryDozSpecificationDto[] {
    return Array.from(this.basketItems);
  }

  public containsSpecification(specification: RegistryDozSpecificationDto): boolean {
    return this.basketItems.has(specification);
  }

  public setupSelectedBaseId(selectedBaseId: number): void {
    this.selectedBaseId = selectedBaseId;
  }

  public add(item: RegistryDozSpecificationDto): void {
    this.basketItems.add(item);
    const beneficiaryId = this.findBeneficiaryId(item);
    if (beneficiaryId !== -1) {
      this.beneficiaryIds.add(beneficiaryId);
    }
    console.log(this.beneficiaryIds);
  }

  private findBeneficiaryId(item: RegistryDozSpecificationDto): number {
    let retValue = -1;
    if (!this.selectedBaseId) {
      return retValue;
    }
    item.beneficiaries?.forEach(beneficiary => {
      if (beneficiary.organizationId === this.selectedBaseId) {
        retValue = beneficiary.id || -1;
      }
    });

    return retValue;
  }

  public delete(item: RegistryDozSpecificationDto): void {
    this.basketItems.delete(item);
    this.beneficiaryIds.delete(this.findBeneficiaryId(item));
  }

  public clear(): void {
    this.basketItems.clear();
    this.selectedBaseId = 0;
    this.beneficiaryIds = new Set();
  }
}
